import { Link, useLocation, useNavigate } from 'react-router-dom'
import './styles/panelcontrol.css'

//Extras
import { fontType, main } from '../assets/extras'
import { useEffect, useState } from 'react'

//Components
import Menu from '../components/menu'
import Loader from '../components/loader'
import { version } from '../assets/datas'

const PanelControl = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [ users, setUsers ] = useState([])
    const [ loading, setLoading ] = useState(false)

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        }

        setUsers(JSON.parse(localStorage.getItem("users")))
    }, [])

    if(loading)
        return (
            <Loader
                loading={loading}
            />
        )

    if(!loading)
    return (
        <div className='mainPanelControl'>

            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>ADMINISTRACION</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -40,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ? 
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <Menu
                academia={academia}
                reference={ref}
            />

            {
                users.length > 0 ? 
                    <div className='contPagos' style={{
                        marginBottom: 50
                    }}>
                        <p style={{
                            fontFamily: fontType.text
                        }}>Cambiar de centro</p>

                        <div className='custom-select'>
                            <select id="Rama" name="Rama" style={{
                                fontFamily: fontType.text
                            }}
                                onChange={e => {
                                    setLoading(true)

                                    setTimeout(() => {
                                        const data = e.target.value

                                        localStorage.setItem("authToken", data)

                                        setTimeout(() => {
                                            navigate("/home")
                                        }, 50)

                                    }, 1000)

                                }}
                            >
                                <option value={""}>Seleccionar centro</option>
                                {
                                    users.map((v, i) => {
                                        return (
                                            <option value={JSON.stringify(v)}>{v.nombre_academia}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                : null
            }

            <Link to={"/controlpanel/assistances/"} state={{
                ref: ref,
                academia: academia
            }} id='button' style={{
                backgroundColor: main,
                fontFamily: fontType.subTitle,
                width: "40%",
                marginBottom: 30
            }}>ASISTENCIAS</Link>
            
            <div className='contPagos'>
                <p style={{
                    fontFamily: fontType.text
                }}>Suscripciones y pagos</p>

                <div>
                    <Link to={"/controlpanel/suscriptions/"} state={{
                        ref: ref,
                        academia: academia
                    }} id='button' style={{
                        backgroundColor: main,
                        fontFamily: fontType.subTitle
                    }}>SUSCRIPCIONES</Link>

                    {<Link to={"/controlpanel/finances/"} state={{
                        ref: ref,
                        academia: academia
                    }} id='button' style={{
                        backgroundColor: main,
                        fontFamily: fontType.subTitle
                    }}>FINANZAS</Link>}
                </div>
            </div>

            <Link to={"/sedes"} state={{
                ref: ref,
                academia: academia
            }} id='button' style={{
                backgroundColor: main,
                fontFamily: fontType.subTitle,
                width: "85%",
                marginBottom: 10,
                marginTop: 30
            }}>SEDES</Link>

            <Link to={"/controlpanel/clasesmuestra/"} state={{
                ref: ref,
                academia: academia
            }} id='button' style={{
                backgroundColor: main,
                fontFamily: fontType.subTitle,
                width: "85%",
                marginBottom: 30,
                marginTop: 30
            }}>CLASES MUESTRA</Link>

            <button style={{
                marginBottom: 20
            }} className='logoutbutton' onClick={() => {
                localStorage.removeItem("authToken")
                sessionStorage.removeItem("homeFlag")

                window.location.href = "/login"
            }}>
                CERRAR SESION
            </button>

            <p style={{
                position: "absolute",
                left: 0,
                bottom: 0,
                padding: 2,
                color: "gray"
            }}>{version}</p>
        </div>
    )
}

export default PanelControl